import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    padding: theme.spacing(1, 0),
    "& a": {
      color: "#009688",
    },
  },
}));

export default useStyles;
